// src/features/merchantConfig/components/states/NotProvisionedEmptyState.jsx
//
// Shown when a category returns 404 / RECORD_NOT_FOUND. This is a first-class
// "the merchant hasn't been provisioned for this setting yet" state — NOT a
// generic error (UI prompt §6, §8).

import React from "react";
import { Inbox, LifeBuoy } from "lucide-react";

/**
 * @param {{ categoryDisplayName: string, onContactSupport?: () => void }} props
 */
export default function NotProvisionedEmptyState({ categoryDisplayName, onContactSupport }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 bg-white px-6 py-14 text-center"
      role="status"
    >
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 text-gray-500">
        <Inbox className="h-7 w-7" aria-hidden="true" />
      </div>
      <h2 className="text-base font-semibold text-gray-900">
        {categoryDisplayName
          ? `${categoryDisplayName} isn't configured yet`
          : "This setting isn't configured yet"}
      </h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-gray-600">
        This configuration hasn't been set up for your account yet. Contact
        support if you'd like to enable it.
      </p>
      <button
        type="button"
        onClick={onContactSupport}
        className="mt-5 inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      >
        <LifeBuoy className="h-4 w-4" aria-hidden="true" />
        Contact support
      </button>
    </div>
  );
}
